const values = {
    HOST: 'http://localhost:8084',
    // HOST: 'https://3irq0dy6nd.execute-api.us-east-1.amazonaws.com/prod',
};
export default values;
